import React from "react";
import PropTypes from "prop-types";

function PaymentSchedulePreview({ items }) {
  return (
    <div className="table-responsive mt-3">
      <table className="table table-sm">
        <thead>
          <tr>
            <th>Termin</th>
            <th>Opis</th>
            <th>Kwota</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => (
            <tr key={item.id}>
              <td>{item.dueDate}</td>
              <td>{item.description}</td>
              <td>{item.amount}</td>
              <td>{item.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

PaymentSchedulePreview.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    dueDate: PropTypes.string.isRequired,
    description: PropTypes.string,
    amount: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  })),
};

PaymentSchedulePreview.defaultProps = {
  items: [],
};

export default PaymentSchedulePreview;
